import { z } from 'zod';
/**
 * Beklenen barkod listesi — o gün sahada okutulması gereken kodlar.
 *
 * Eski projede tek bir Firestore dokümanının içinde dizi olarak duruyordu
 * (`rabibarkodlar/barkodlar`) ve 1 MB doküman sınırına yaklaşıyordu. Kalan
 * sayısı da her ekran güncellemesinde client'ta yeniden hesaplanıyordu
 * (rabiekle.dart:122): 1000 barkod × 500 okuma = her karede yarım milyon
 * karşılaştırma. Burada satır satır saklanıyor ve sayım veritabanında yapılıyor.
 */
export const expectedStatsSchema = z.object({
    /** Listedeki toplam barkod. */
    total: z.number().int(),
    /** Bugün okutulmuş olanlar. */
    scanned: z.number().int(),
    /** Henüz okutulmamış olanlar. */
    remaining: z.number().int(),
});
export const importExpectedSchema = z.object({
    /**
     * Yapıştırılan ham metin. Satır, virgül, noktalı virgül veya sekme ile
     * ayrılmış kodlar kabul edilir — kullanıcı Excel'den de kopyalayabilir.
     */
    text: z.string().min(1, 'Barkod listesi boş olamaz'),
    /** true ise mevcut liste silinip yerine bu yazılır. */
    replace: z.boolean().default(true),
});
export const importResultSchema = z.object({
    /** Metinden ayrıştırılan geçerli kod sayısı. */
    parsed: z.number().int(),
    /** Listeye eklenen (tekrarlar düşülmüş). */
    inserted: z.number().int(),
    /** Zaten listede olduğu için atlanan. */
    duplicates: z.number().int(),
    total: z.number().int(),
});
/**
 * Ham metinden barkod listesi çıkarır.
 *
 * Hem client hem sunucu aynı fonksiyonu kullanır: kullanıcı yapıştırdığı anda
 * kaç kod olduğunu görür, sunucu da aynı sonucu üretir.
 */
export function parseBarcodeList(text) {
    const seen = new Set();
    const out = [];
    for (const parca of text.split(/[\r\n,;\t]+/)) {
        const kod = parca.trim();
        if (!kod)
            continue;
        if (seen.has(kod))
            continue;
        seen.add(kod);
        out.push(kod);
    }
    return out;
}
//# sourceMappingURL=expected.js.map